import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Chip,
  Stack,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const KeywordHeader = ({ 
  onAddKeyword, 
  onOpenFilter,
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusFilterChange
}) => {
  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
          Mediabuying Keywords
        </Typography>
        <Stack direction="row" spacing={1}>
          <Chip
            label="Performance Tracking"
            color="primary"
            icon={<TrendingUpIcon />}
            sx={{ fontSize: '0.9rem', fontWeight: 'bold', py: 1, px: 2 }}
          />
          <Chip
            label="Fast Track VIP Access"
            color="secondary"
            icon={<FlashOnIcon />}
            sx={{ fontSize: '0.9rem', fontWeight: 'bold', py: 1, px: 2 }}
          />
        </Stack>
      </Stack>
      
      <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary', fontStyle: 'italic' }}>
        Manage your keywords, track performance metrics, and optimize your campaigns for better ROI.
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 2, mb: 4, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ flex: 1, minWidth: '250px', position: 'relative' }}>
          <TextField
            label="Search Keywords"
            variant="outlined"
            fullWidth
            value={searchQuery}
            onChange={onSearchChange}
            InputProps={{
              startAdornment: <SearchIcon color="action" sx={{ mr: 1 }} />,
            }}
          />
        </Box>
        
        <FormControl sx={{ flex: 1, minWidth: '250px' }}>
          <InputLabel>Status Filter</InputLabel>
          <Select
            multiple
            value={statusFilter}
            onChange={onStatusFilterChange}
            input={<OutlinedInput label="Status Filter" />}
            renderValue={(selected) => selected.join(', ')}
          >
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="paused">Paused</MenuItem>
            <MenuItem value="inactive">Inactive</MenuItem>
          </Select>
        </FormControl>
        
        <Stack direction="row" spacing={2}>
          <Button 
            variant="outlined" 
            startIcon={<FilterListIcon />}
            onClick={onOpenFilter}
            sx={{ height: '56px', whiteSpace: 'nowrap' }}
          >
            Advanced Filter
          </Button>
          <Button 
            variant="contained" 
            startIcon={<AddIcon />} 
            onClick={onAddKeyword}
            sx={{ height: '56px', whiteSpace: 'nowrap' }}
          >
            Add Keyword
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default KeywordHeader; 